import { render, staticRenderFns } from "./PayactivScreens.vue?vue&type=template&id=3af18d1b&scoped=true&"
import script from "./PayactivScreens.vue?vue&type=script&lang=js&"
export * from "./PayactivScreens.vue?vue&type=script&lang=js&"
import style0 from "./PayactivScreens.vue?vue&type=style&index=0&id=3af18d1b&scoped=true&lang=css&"
import style1 from "./PayactivScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af18d1b",
  null
  
)

export default component.exports